/**
 * Connect network folder (SAMBA/NFS resource).
 */

'use strict';

var app                = require('mag-app'),
    keys               = require('stb-keys'),
    Page               = require('stb-component-page'),
    Panel              = require('mag-component-panel'),
    PanelSet           = require('mag-component-panel-set'),
    LayoutList         = require('mag-component-layout-list'),
    ModalMessage       = require('mag-component-modal'),
    Button             = require('stb-component-button'),
    div                = require('../modules/div'),
    mediaTypes         = require('../modules/types').media,
    openKeyboard       = require('../modules/keyboard').open,
    page               = new Page({$node: document.getElementById('pageConnect')}),
    activeMountType    = mediaTypes.smb.id,
    dataSmb            = {
        server:       '',
        folderServer: '',
        folderLocal:  '',
        login:        '',
        password:     ''
    },
    dataNfs            = {
        server:       '',
        folderServer: '',
        folderLocal:  ''
    },
    selectMountTypeModal,
    panelSet;


/** Construct components and render page. */
// eslint-disable-next-line max-lines-per-function
function renderPage () {
    var $serverNFS, $folderServerNFS, $folderLocalNFS,
        $serverSMB, $folderServerSMB, $folderLocalSMB,
        $login, $password,
        mountSMBInputs, mountNFSInputs, panelList, buttonConnect;

    buttonConnect = new Button({
        value:     gettext('Connect'),
        className: 'bottom theme-footer',
        events: {
            click: function () {
                if ( activeMountType === mediaTypes.smb.id ) {
                    app.emit('connectSMB', {
                        shareType: mediaTypes.smbPermanentShare.id,
                        info: {
                            address:     dataSmb.server,
                            name:        dataSmb.folderServer,
                            displayName: dataSmb.folderLocal,
                            login:       dataSmb.login,
                            password:    dataSmb.password
                        },
                        callback: function ( error ) {
                            if ( error ) {
                                core.notify({
                                    title: gettext(error.message),
                                    icon: 'alert',
                                    type: 'warning'
                                });
                            } else {
                                app.route(app.pages.main);
                            }
                        }
                    });
                } else {
                    app.emit('connectNFS', {
                        shareType: mediaTypes.nfsPermanentShare.id,
                        info: {
                            address:     dataNfs.server,
                            name:        dataNfs.folderServer,
                            displayName: dataNfs.folderLocal
                        },
                        callback: function ( error ) {
                            if ( error ) {
                                core.notify({
                                    title: gettext(error.message),
                                    icon: 'alert',
                                    type: 'warning'
                                });
                            } else {
                                app.route(app.pages.main);
                            }
                        }
                    });
                }
            },
            keydown: function ( event ) {
                if ( event.code === keys.up ) {
                    panelList.focus();
                    panelList.$focusItem.classList.add('focus');
                    panelList.focusIndex(panelList.data.length - 1);
                } else if ( event.code === keys.down ) {
                    panelList.focus();
                    panelList.$focusItem.classList.add('focus');
                    panelList.focusIndex(0);
                } else if ( event.code === keys.ok ) {
                    buttonConnect.emit('click', {event: event});
                }
            }
        }
    });

    selectMountTypeModal = new ModalMessage({
        parent: page,
        title: gettext('Connection type'),
        events: {
            hide: () => panelSet.focus()
        },
        children: [
            new LayoutList({
                className: 'padded',
                cycle: true,
                size: 2,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            {
                                value: 'SMB'
                            }
                        ],
                        click: function () {
                            if ( activeMountType === mediaTypes.nfs.id ) {
                                panelList.setData({
                                    data: mountSMBInputs,
                                    focusIndex: panelList.links.mountType.$parentItem.index
                                });

                                $serverSMB.innerText       = dataSmb.server;
                                $folderServerSMB.innerText = dataSmb.folderServer;
                                $folderLocalSMB.innerText  = dataSmb.folderLocal;

                                activeMountType = mediaTypes.smb.id;
                                this.focusIndex = 0;
                            }

                            selectMountTypeModal.hide();
                        }
                    },
                    {
                        items: [
                            {
                                value: 'NFS'
                            }
                        ],
                        click: function () {
                            if ( activeMountType === mediaTypes.smb.id ) {
                                panelList.setData({
                                    data: mountNFSInputs,
                                    focusIndex: panelList.links.mountType.$parentItem.index
                                });

                                $serverNFS.innerText       = dataNfs.server;
                                $folderServerNFS.innerText = dataNfs.folderServer;
                                $folderLocalNFS.innerText  = dataNfs.folderLocal;

                                activeMountType = mediaTypes.nfs.id;
                                this.focusIndex = 1;
                            }

                            selectMountTypeModal.hide();
                        }
                    }
                ]
            })
        ]
    });

    mountSMBInputs = [
        {
            items: [
                {
                    value: gettext('Server address') + ':',
                    className: 'theme-subhead-color'
                },
                $serverSMB = div(),
                {
                    className: 'theme-item-editable disabled'
                }
            ],
            click: function () {
                openKeyboard({
                    title: gettext('ENTER SERVER ADDRESS'),
                    value: dataSmb.server
                }, function ( event ) {
                    $serverSMB.innerText = dataSmb.server = event.value;
                });
            }
        },
        {
            items: [
                {
                    value: gettext('Server folder') + ':',
                    className: 'theme-subhead-color'
                },
                $folderServerSMB = div(),
                {
                    className: 'theme-item-editable disabled'
                }
            ],
            click: function () {
                openKeyboard({
                    title: gettext('ENTER SERVER FOLDER NAME'),
                    value: dataSmb.folderServer
                }, function ( event ) {
                    $folderServerSMB.innerText = dataSmb.folderServer = event.value;

                    if ( !dataSmb.folderLocal ) {
                        $folderLocalSMB.innerText = dataSmb.folderLocal = event.value;
                    }
                });
            }
        },
        {
            items: [
                {
                    value: gettext('Local folder') + ':',
                    className: 'theme-subhead-color'
                },
                $folderLocalSMB = div(),
                {
                    className: 'theme-item-editable disabled'
                }
            ],
            click: function () {
                openKeyboard({
                    title: gettext('ENTER FOLDER NAME'),
                    value: dataSmb.folderLocal
                }, function ( event ) {
                    $folderLocalSMB.innerText = dataSmb.folderLocal = event.value || dataSmb.folderServer;
                });
            }
        },
        {
            name: 'mountType',
            items: [
                {
                    value: gettext('Connection type') + ':',
                    className: 'theme-subhead-color'
                },
                {
                    value: 'SMB',
                    className: 'mountType'
                },
                {
                    className: 'theme-item-more'
                }
            ],
            click: function () {
                selectMountTypeModal.show();
                selectMountTypeModal.focus();
                panelSet.blur();
            }
        },
        {
            items: [
                {
                    value: gettext('Login') + ':',
                    className: 'theme-subhead-color'
                },
                $login = div(),
                {
                    className: 'theme-item-editable disabled'
                }
            ],
            click: function () {
                openKeyboard({
                    title: gettext('ENTER LOGIN'),
                    value: dataSmb.login
                }, function ( event ) {
                    $login.innerText = dataSmb.login = event.value;
                });
            }
        },
        {
            items: [
                {
                    value: gettext('Password') + ':',
                    className: 'theme-subhead-color'
                },
                $password = div('theme-text-password'),
                {
                    className: 'theme-item-editable disabled'
                }
            ],
            click: function () {
                openKeyboard({
                    title: gettext('ENTER PASSWORD'),
                    type:  'password',
                    value: dataSmb.password
                }, function ( event ) {
                    $password.innerText = dataSmb.password = event.value;
                });
            }
        }
    ];

    mountNFSInputs = [
        {
            items: [
                {
                    value: gettext('Server address') + ':',
                    className: 'theme-subhead-color'
                },
                $serverNFS = div(),
                {
                    className: 'theme-item-editable disabled'
                }
            ],
            click: function () {
                openKeyboard({
                    title: gettext('ENTER SERVER ADDRESS'),
                    value: dataNfs.server
                }, function ( event ) {
                    $serverNFS.innerText = dataNfs.server = event.value;
                });
            }
        },
        {
            items: [
                {
                    value: gettext('Server folder') + ':',
                    className: 'theme-subhead-color'
                },
                $folderServerNFS = div(),
                {
                    className: 'theme-item-editable disabled'
                }

            ],
            click: function () {
                openKeyboard({
                    title: gettext('ENTER SERVER FOLDER NAME'),
                    value: dataNfs.folderServer
                }, function ( event ) {
                    $folderServerNFS.innerText = dataNfs.folderServer = event.value;

                    if ( !dataNfs.folderLocal ) {
                        $folderLocalNFS.innerText = dataNfs.folderLocal = event.value;
                    }
                });
            }
        },
        {
            items: [
                {
                    value: gettext('Local folder') + ':',
                    className: 'theme-subhead-color'
                },
                $folderLocalNFS = div(),
                {
                    className: 'theme-item-editable disabled'
                }
            ],
            click: function () {
                openKeyboard({
                    title: gettext('ENTER FOLDER NAME'),
                    value: dataNfs.folderLocal
                }, function ( event ) {
                    $folderLocalNFS.innerText = dataNfs.folderLocal = event.value || dataNfs.folderServer;
                });
            }
        },
        {
            name: 'mountType',
            items: [
                {
                    value: gettext('Connection type') + ':',
                    className: 'theme-subhead-color'
                },
                {
                    value: 'NFS',
                    className: 'mountType'
                },
                {
                    className: 'theme-item-more'
                }
            ],
            click: function () {
                selectMountTypeModal.show();
                selectMountTypeModal.focus();
                panelSet.blur();
            }
        }
    ];

    page.add(
        panelSet = new PanelSet({
            panels: [
                new Panel({
                    main: true,
                    title: [
                        {
                            value: gettext('Connect network folder'),
                            className: 'name'
                        }
                    ],
                    children: [
                        panelList = new LayoutList({
                            className: 'mountNetworkFolderList',
                            size: (activeMountType === mediaTypes.smb.id ? mountSMBInputs : mountNFSInputs).length,
                            focusIndex: 0,
                            data: activeMountType === mediaTypes.smb.id ? mountSMBInputs : mountNFSInputs,
                            events: {
                                overflow: function () {
                                    panelList.$focusItem.classList.remove('focus');
                                    buttonConnect.focus();
                                }
                            }
                        }),
                        buttonConnect
                    ]
                })
            ]
        })
    );

    panelSet.focus();
}


page.once('show', renderPage);

page.addListener('keydown', function ( event ) {
    if ( event.code === keys.back ) {
        app.route(app.pages.main);
    }
});


module.exports = page;
